import React, { useState, useImperativeHandle } from "react";
import PropTypes from "prop-types";
import RichTextEditor from "../../../../components/RichTextEditor";
import { replaceAll } from "../../../../components/Utils";
import {
  getContentTypeIdFromType,
  CONTENT_HTML,
  toEditableHtml,
} from "../Utils";
import HtmlText from "../../../../components/HtmlText";

const HtmlContentForm = React.forwardRef(({ className, pageId, model, disabled }, ref) => {
  const [body, setBody] = useState(toEditableHtml(model.body));

  useImperativeHandle(ref, () => ({
    getModel: (noValidate) => {
      const { id } = model;
      // formating and cleaning up
      let data = replaceAll(body, "<ul>", "<ul class=\"vf-list no-margin-tb\">");
      data = replaceAll(data, "<p><br></p>", "");
      data = replaceAll(data, "<p></p>", "");
      //
      return {
        id,
        content_type_id: getContentTypeIdFromType(CONTENT_HTML),
        body: data,
      };
    }
  }), [body, model]);

  return (
    <div
      className={`html-content-form ${className} pad-big-`}
      style={{ margin: "-1px" }}
    >
      <div className="pos-rel">
        {disabled ? (
          <div className="pad-tb pad-big-lr w3-border w3-round">
            <HtmlText text={body} />
          </div>
        ) : (
          <RichTextEditor
            className=""
            value={body}
            onChange={(event) => setBody(event.target.value)}
            bounds={`#${pageId}`}
            disabled={disabled}
          />
        )}
      </div>
    </div>
  );
});

HtmlContentForm.displayName = "HtmlContentForm";

HtmlContentForm.propTypes = {
  pageId: PropTypes.string,
  className: PropTypes.string,
  model: PropTypes.shape({}),
  disabled: PropTypes.bool,
};

HtmlContentForm.defaultProps = {
  className: "",
  model: { body: "" },
};

export default HtmlContentForm;
